import React from "react";

import { CardListGrid } from "Projects/CC_cubi_clan_project/GlobalComponents/CardListGrid/CardListGrid";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import Constantes from "Projects/CC_cubi_clan_project/Utils/Constantes";
import { mfmMediumUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";

export class ListaAplicaciones extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      appsData: []
    }

    for (let cardData of this.state.appsData) {
      cardData.imgPath = Constantes.URL_BASE + 
        "boxconv/preview?FileName=" +
        cardData.imgPath;
      cardData.buttonName =
        cardData.estado === "ONLINE" ? "Acceder" : cardData.estado;
    }
  }

  componentDidMount() {
    this.getApps();
  }

  getApps() {
    this.props.onLoading && this.props.onLoading(true);

    doFetch("SSO", "getMyAplicaciones", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const apps = Array.isArray(data?.DATA) ? data.DATA : [];
        for (let appData of apps) {
          switch (appData.estado) {
            case "ONLINE":
              appData.buttonName = "Acceder";
              appData.enabled = true;
              break;
            case "DEMO":
              appData.buttonName = "🔑 Demo";
              appData.enabled = true;
              break;
            default:
              appData.buttonName = appData.estado;
              appData.enabled = false;
              break;
          }

          if (appData.imageUuid) {
            appData.appImg = mfmMediumUrl(appData.imageUuid);
          } else if (appData.appImg && !/^https?:\/\//i.test(appData.appImg) && !appData.appImg.startsWith("data:")) {
            appData.appImg =
              Constantes.URL_BASE + "boxconv/preview?FileName=" + appData.appImg;
          }

        }
        this.setState({ appsData: apps.filter(element => element.nombre !== "SSO") });
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading && this.props.onLoading(false);
      });
  }

  handleCardListAction = (event) => {
    if (event) {
      console.log("Acción en card:", event.nombre);
      switch (event.nombre) {
        case "BOX":
          this.props.onNavigate("/box");
          break;
        case "CCON":
          this.props.onNavigate("/ccon");
          break;
        case "TABL":
          this.props.onNavigate("/tabl");
          break;
        case "HAPK":
          this.props.onNavigate("/hapk");
          break;
        case "MFM":
          this.props.onNavigate("/mfm");
          break;
        case "MTA":
          this.props.onNavigate("/mta");
          break;
        case "CHAMP":
          this.props.onNavigate("/champ");
          break;
        case "TEAN":
        case "Teansari": {
          const isLocal =
            window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1";
          const targetHost = isLocal ? "127.0.0.1" : "teansari.cubiclan.com";
          const targetUrl = `${window.location.protocol}//${targetHost}${window.location.port ? `:${window.location.port}` : ""}/`;
          window.location.href = targetUrl;
          break;
        }
        case "MUGIN": {
          const isLocal =
            window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1";
          const targetHost = isLocal ? "127.0.0.1" : "mugin.cubiclan.com";
          const targetUrl = `${window.location.protocol}//${targetHost}${window.location.port ? `:${window.location.port}` : ""}/`;
          window.location.href = targetUrl;
          break;
        }
        default:
          break;
      }
    }
  };

  render() {
    return (
      <CardListGrid
        data={this.state.appsData}
        onAction={this.handleCardListAction}
        expandImageOnHover={false}
        uniformCards={true}
      />
    );
  }
}
